import {ApiErrorObject} from '@auth/data-access';

export namespace CycleApiErrors {
	export namespace ErrorTypes {
		export function isCycleTriggerError(error: ApiErrorObject): boolean {
			return error.id === 'trigger_error';
		}
	}
}
